<template>
    <div class="d-flex justify-content-center">
        <div class="web-camera-container">
            <div class="video-options">
                <select v-model="deviceId" class="custom-select">
                    <option :value="videoDevice.deviceId" v-for="(videoDevice, index) in videoDevices"
                                    :key="index">{{ videoDevice.label }}</option>
                </select>
            </div>

            <div v-if="isCameraOpen" class="camera-box" :class="{ 'flash': isShotPhoto }">

                <div class="camera-shutter" :class="{ 'flash': isShotPhoto }"></div>

                <video v-show="!isPhotoTaken" id="camera" ref="camera" :width="'100%'" :height="393.75" autoplay></video>

                <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="getwith" :height="getheight"></canvas>
            </div>

            <div v-show="isLoading" class="camera-loading">
                <ul class="loader-circle">
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>

            <div v-if="isCameraOpen && !isLoading" class="camera-shoot mb-0">
                <button type="button" class="btn btn-primary" @click="takePhoto">
                    Hacer una foto
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        closecamare: Boolean
    },
    data() {
        return {
            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoading: false,
            link: '#',
            count: 0,
            getheight: 0,
            getwith: 0,
            videoDevices: [],
            deviceId: ''
        }
    },
    created() {
        let vue = this
        vue.getCameraSelection()
        vue.isLoading = true
        setTimeout(() => {
            if(vue.videoDevices.length > 0){
                vue.deviceId = vue.videoDevices[0].deviceId
                vue.isCameraOpen = true
                vue.createCameraElement(vue.deviceId)
            }
        }, 500)
    },
    methods: {
        getCameraSelection(){
            let vue = this
            navigator.mediaDevices.enumerateDevices().then((e) => {
                e.forEach(element => {
                    if(element.kind  === 'videoinput'){
                        vue.videoDevices.push({
                            deviceId: element.deviceId,
                            groupId: element.groupId,
                            kind: element.kind,
                            label: element.label,
                        })
                    }
                })
            })
        },
        async createCameraElement(value) {
            this.isLoading = true
            const constraints = {
                audio: false,
                video: {
                    optional: [{
                        sourceId: value
                    }]
                },
                deviceId: {
                    exact: value
                }
            }
            await navigator.mediaDevices.getUserMedia(constraints)
                .then(stream => {
                    this.isLoading = false
                    this.$refs.camera.srcObject = stream
                })
                .catch(error => {
                    this.isLoading = false
                    alert("May the browser didn't support or there is some errors.")
                    this.$emit('closeerror')
                })
        },
        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks()
            tracks.forEach(track => {
                track.stop()
            })
        },
        takePhoto() {
            let vue = this
            var vid = document.getElementById("camera")
            if(vid){
                vue.getwith = vid.videoWidth
                vue.getheight = vid.videoHeight
            }
            vue.count++
            vue.isLoading = true
            if (vue.count == 1) {
                if (!vue.isPhotoTaken) {
                    vue.isShotPhoto = true
                    const FLASH_TIMEOUT = 50
                    setTimeout(() => {
                        vue.isShotPhoto = false

                        const context = vue.$refs.canvas.getContext('2d')
                        context.drawImage(vue.$refs.camera, 0, 0, vue.getwith, vue.getheight)
                        
                        const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
                        .replace("image/jpeg", "image/octet-stream")
                        
                        const genRandonString = () => {
                            let result = 'capture-' + moment().format('DDMMYYhhmmss')
                            return result
                        }

                        function dataURLtoFile(dataurl, filename) {
                            var arr = dataurl.split(','),
                                mime = arr[0].match(/:(.*?);/)[1],
                                bstr = atob(arr[arr.length - 1]), 
                                n = bstr.length, 
                                u8arr = new Uint8Array(n);
                            while(n--){
                                u8arr[n] = bstr.charCodeAt(n);
                            }
                            return new File([u8arr], filename, {type:mime});
                        }

                        let file = dataURLtoFile(canvas, genRandonString() + '.jpeg')

                        const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
                            const byteCharacters = atob(b64Data);
                            const byteArrays = [];
                            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                                const slice = byteCharacters.slice(offset, offset + sliceSize);
                                const byteNumbers = new Array(slice.length);
                                for (let i = 0; i < slice.length; i++) {
                                    byteNumbers[i] = slice.charCodeAt(i);
                                }
                                const byteArray = new Uint8Array(byteNumbers);
                                byteArrays.push(byteArray);
                            }
                            const blob = new Blob(byteArrays, { type: contentType });
                            return blob;
                        }
                        
                        const contentType = 'image/jpeg';
                        const b64Data = canvas.split('base64,');
                        const blob = b64toBlob(b64Data[1], contentType);
                        
                        file.path = URL.createObjectURL(blob)

                        vue.$emit('capture', file)
                        vue.count = 0
                        vue.isLoading = false
                    }, FLASH_TIMEOUT)
                }
            }
        },
    },
    watch: {
        closecamare: {
            handler(value) {
                if (this.isCameraOpen) {
                    this.isCameraOpen = false
                    this.isPhotoTaken = false
                    this.isShotPhoto = false
                    this.stopCameraStream()
                }
            }
        },
        deviceId: {
            handler(value) {
                this.isCameraOpen = true
                this.createCameraElement(value)
            }
        }
    }
}
</script>
<style>
.web-camera-container {
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
}

.camera-button {
    margin-bottom: 2rem;
}

.camera-box .camera-shutter {
    opacity: 0;
    width: 100%;
    height: 393.75px;
    background-color: #fff;
    position: absolute;

    &.flash {
        opacity: 1;
    }
}

.camera-shoot {
    margin: 1rem 0;
}

.camera-loading {
    overflow: hidden;
    height: 100%;
    position: relative;
    width: 100%;
    min-height: 14px;
    margin: 3rem 0 0 -1.2rem;
}

ul {
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 999999;
    margin: 0;
}

.loader-circle {
    display: block;
    height: 14px;
    margin: 0 auto;
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    transform: translateX(-50%);
    position: absolute;
    width: 100%;
    padding: 0;
}

li {
    display: block;
    float: left;
    width: 10px;
    height: 10px;
    line-height: 10px;
    padding: 0;
    position: relative;
    margin: 0 0 0 4px;
    background: #999;
    animation: preload 1s infinite;
    top: -50%;
    border-radius: 100%;

    &:nth-child(2) {
        animation-delay: .2s;
    }

    &:nth-child(3) {
        animation-delay: .4s;
    }
}

@keyframes preload {
    0% {
        opacity: 1
    }

    50% {
        opacity: .4
    }

    100% {
        opacity: 1
    }
}</style>


// WEBPACK FOOTER //
// src/components/others/Camera.vue